import React from 'react';
import './Tooltip.css';

const Tooltip = ({ children, text, id, label, placement = 'top-center' }) => {
  return (
    <div className="tooltip-wrapper">
      {children}
      <div className={`tooltip-content tooltip-${placement}`}>
        <span>{text}</span>
    </div>
    </div>
  );
};

export default Tooltip;